import { NodeModel } from "../_model/NodeModel";
import { DecorationProductionChangeEditable } from "./decorationProductionChangeEditable"
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { Types } from "../../utils/nodeTypes"
import Properties from "../_model/ModelEngineeringProperties";
import ButtonSelect from "./buttonSelected";
import VisibleControl from "../../utils/visibleControl";
import { SingletonInter } from "../_service/singletonInter";

class ProductionChangeEditable extends NodeModel {
  constructor() {
    super("ProductionChangeEditable");
    
    this.type = new Types().ProductionChangeEditable;
    this.x = 0;
    this.y = 0;
    this.height = 20;
    this.width = 122;
    this.widthOption = 60;
    this.dataType = null
    this.buttons = [ new ButtonSelect({caption:"Opção 1", value:1}), new ButtonSelect({caption:"Opção 2", value:2}), new ButtonSelect({caption: "Opção 3", value:3})]
    this.data = [ ]

    this.title = SingletonInter.$t('selecione-uma-operacao-ou-corrente')
    this.fontSize = "11px"
    this.xTextDescription = () => this.x + 5;
    this.yTextDescription = () => this.y + 16;

    this.xBox = () => this.x;
    this.yBox = (step) => this.y + (step * 21.5);
    this.widthBox = () => this.width;
    this.heightBox = () => this.height;
    this.xText = () => this.xBox() + 5;
    this.yText = (step) => this.y + (step * 21.5) + 13;

    this.indexSelect = function (index){
      if(this.data[0] && index > -1) {
        this.data[0].value =  this.buttons[index].value
        VisibleControl.setByPropertie(this.data[0])
      }
      return this.data[0] ? this.data[0].value : 0
    }

    this.buttonSelected = function(){
      let value = SingletonEnginnering.getValue(this.data[0])
      let index = 0
      this.buttons.forEach((b, i) => {
        if(b.value == value) {
          index = i
        }
      })
      return index
    }
    
    this.decorate = async function(callback) {
      this.decorator = new DecorationProductionChangeEditable();
      await this.decorator.init(this,callback)
    };

    this.update = function(nodeEdited) {
      this.buttons = nodeEdited.buttons
      this.title = nodeEdited.title
      this.data = nodeEdited.data
      this.dataType = nodeEdited.dataType
      this.decorator.update()
    }

    this.clone = () => {
      let cloned = new ProductionChangeEditable();
      cloned.type = this.type
      cloned.x = this.x
      cloned.y = this.y
      cloned.height = this.height
      cloned.width = this.width
      cloned.title = this.title
      cloned.readOnly = this.readOnly
      cloned.dataType = this.dataType
      cloned.readOnly = this.readOnly;
      cloned.expressionVisible = this.expressionVisible
      cloned.data = this.data.map(d => d.clone())
      cloned.buttons = this.buttons.map(b => b.clone())

      return cloned
    }

    this.copyFrom = (node) => {
      this.simpleCopyFrom(node);
      this.dataType = node.dataType
      this.title = node.title
      this.data = node.data.map(d => new Properties({...d, id: '' }))
      this.buttons = node.buttons.map(b => new ButtonSelect({...b}))
    }
  }
}


export { ProductionChangeEditable };
